export default __webpack_public_path__ + "static/media/pg-icon2.9cd20b3d.png";